import {createApp} from 'vue'
import Store from 'store'
import ProductSpot from './ProductSpot'

const component = createApp(ProductSpot).use(Store)

const el = '.nlx-component--product-spot'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

